const node = document.querySelector('.add-form');

class TelemetryEvent {
  constructor(nodeElement) {
    // settings
    this.node = nodeElement || document;
    this.requestDelay = 3000;
    this.textDelay = 1000;
    this.url = 'https://sopr-api.cian.ru/telemetry/';
    this.telemetry = { client: {}, events: [] };

    // binds
    this.sendData = this._sendData.bind(this);
    this.updateUserId = this._updateUserId.bind(this);
  }

  _createFormId() {
    const formId = new Date().getTime().toString();
    window.formId = formId;

    return formId;
  }

  _installTelemetryClient() {
    const sessionId = this._getCookieByName('_CIAN_GK');
    const formId = this._createFormId();

    this.telemetry.client = {
      sessionId,
      userId: null,
      formId,
    };
  }

  _updateUserId() {
    this.telemetry.client.userId = this._getCookieByName('cian_ruid') || this._getCookieByName('_CIAN_GK') || '';
  }

  _getCookieByName(name) {
    const cookie = document.cookie.match(new RegExp(name + '=([^;]+)'));

    return cookie && cookie.length && cookie[1];
  }

  _startListeningEvents() {
    const keyupHandler = this._keyupHandler.bind(this);
    const keydownHandler = this._keydownHandler.bind(this);
    const validateTypeFiled = this._validateTypeFiled.bind(this);

    this.node.addEventListener('click', this._clickHandler.bind(this), false);

    this.node.addEventListener(
      'keydown',
      e => {
        if (!validateTypeFiled(e.target)) {
          return;
        }
        keydownHandler(e);
      },
      false,
    );

    this.node.addEventListener(
      'keyup',
      e => {
        if (!validateTypeFiled(e.target)) {
          return;
        }

        e.target.isThrottle = e.target.hasOwnProperty('isThrottle') ? e.target.isThrottle : false;

        if (!e.target.isThrottle) {
          e.target.isThrottle = true;
          setTimeout(() => {
            e.target.isThrottle = false;
            keyupHandler(e);
          }, this.textDelay);
        }
      },
      false,
    );
  }

  _clickHandler(e) {
    this._addTelemetryEvent(e.target, e.type);
  }

  _keydownHandler(e) {
    const target = e.target;

    if (target && !target.hasOwnProperty('previousValue')) {
      target.previousValue = e.target.value;
    }
  }

  _keyupHandler(e) {
    const value = e.target.value;
    const previousValue = e.target.previousValue;
    const currentValue = value;

    this._addTelemetryEvent(e.target, 'change', { currentValue, previousValue });

    e.target.previousValue = e.target.value;
  }

  _validateTypeFiled(element) {
    const tag = element.tagName.toLowerCase();

    return (tag === 'input' && element.type === 'text') || tag === 'textarea';
  }

  _addTelemetryEvent(element, type, value) {
    let obj = {
      dom: this._collectDomElements(element),
      type,
      date: new Date().toString(),
    };

    if (value) {
      obj.previousValue = value.previousValue;
      obj.currentValue = value.currentValue;
    }

    this.telemetry.events.push(obj);
  }

  _collectDomElements(element) {
    const data = [];
    let el = element;

    while (el) {
      data.push({
        id: el.id,
        el: el.tagName,
        title: el.title,
        class: el.className,
        datamark: el.dataset && el.dataset.hasOwnProperty('mark') ? el.dataset.mark : '',
      });

      el = el.parentElement;
    }

    return data;
  }

  _sendData() {
    if (this.telemetry.events.length === 0) {
      setTimeout(this.sendData, this.requestDelay);

      return;
    }

    const xhr = new XMLHttpRequest();
    const requestHandler = this._requestHandler.bind(this);
    const size = this.telemetry.events.length;
    let data;

    this.updateUserId();
    try {
      data = JSON.stringify(this.telemetry);

      xhr.open('POST', this.url, true);
      xhr.onreadystatechange = () => requestHandler(xhr, size);
      xhr.send(data);
      // eslint-disable-next-line no-empty
    } catch (e) {
      /* Catches "JSON.stringify cannot serialize cyclic structures." */
    }
  }

  _requestHandler(res, size) {
    if (res.readyState === 4) {
      if (res.status === 200) {
        this.telemetry = {
          client: this.telemetry.client,
          events: this.telemetry.events.slice(size),
        };
      }

      setTimeout(this.sendData, this.requestDelay);
    }
  }

  init() {
    this._installTelemetryClient();
    this._startListeningEvents();
    setTimeout(this.sendData, this.requestDelay);
  }
}

new TelemetryEvent(node).init();
